import * as React from 'react';

interface IProps {
  isValid: boolean;
}

export default function urlStatusIcon(props: IProps) {
  const { isValid } = props;

  const styles: React.CSSProperties = {
    color: isValid ? '#3c763d' : '#FFC526',
    fontSize: '20px',
    position: 'absolute',
    right: '20px',
    top: '12px',
  };

  const icon = isValid ? 'fa-check' : 'fa-exclamation-triangle';

  return (
    <span style={styles}>
      <i className={`fal ${icon} animated animate__fadeIn`} />
    </span>
  );
}
